import { createAction } from 'redux-act';

/** Полезная нагрузка формы дивидендов (данные с бэка или для создания). */
export type DividendFormPayload = Record<string, unknown> | null;

export const setDividendModalVisible = createAction<boolean>('SET_DIVIDEND_MODAL_VISIBLE');
export const setDividendForm = createAction<DividendFormPayload>('SET_DIVIDEND_FORM');
export const closeDividendForm = createAction('CLOSE_DIVIDEND_FORM');
